import { render, staticRenderFns } from "./UploadDocumentYardList.vue?vue&type=template&id=0384b4f2&"
import script from "./UploadDocumentYardList.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentYardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports